/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Sku_Free_HintInputs */



/**
* | output |
* | --- |
* | "For any server, on the shared Colossus bot." |
*
* @param {Plan_Sku_Free_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const plan_sku_free_hint = /** @type {((inputs?: Plan_Sku_Free_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Sku_Free_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для любого сервера, на общем боте Colossus.")
	return /** @type {LocalizedString} */ ("For any server, on the shared Colossus bot.")
});